import { render, staticRenderFns } from "./PaidMembershipChangeConfirmPage.vue?vue&type=template&id=27c79ffa&scoped=true"
import script from "./PaidMembershipChangeConfirmPage.vue?vue&type=script&lang=ts"
export * from "./PaidMembershipChangeConfirmPage.vue?vue&type=script&lang=ts"
import style0 from "./PaidMembershipChangeConfirmPage.vue?vue&type=style&index=0&id=27c79ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c79ffa",
  null
  
)

export default component.exports